// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"58a0c106","460":"c6351f3e","532":"e1195930","564":"b60e43cf"}[chunkId] + ".chunk.css";
};